import type { FC } from 'react';
import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Button, Label } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';
import { InfoBoxContainer } from '../InfoBox';
import AllSetImage from '../../../assets/undraw-setup-up-direct-debit.svg';

interface LowBalanceManualPaymentInfoBoxProps {
  handleClickButton: () => void;
}

export const LowBalanceManualPaymentInfoBox: FC<
  LowBalanceManualPaymentInfoBoxProps
> = ({ handleClickButton }) => {
  const { t } = useTranslation();

  return (
    <InfoBoxContainer
      image={
        <img src={AllSetImage} alt="" width={210} style={{ marginTop: 30 }} />
      }
      content={
        <Stack
          sx={{
            justifyContent: 'center',
            alignItems: 'flex-start',
            height: '100%',
          }}
        >
          <Label
            sx={{
              mb: 3,
              p: 1.8,
              bgcolor: 'warning.main',
              color: 'white',
            }}
            variant="filled"
          >
            {t('fm-triggered-payments.dashboard-cards.low-balance.label')}
          </Label>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            {t('fm-triggered-payments.dashboard-cards.low-balance.description')}
          </Typography>

          <Button variant="contained" onClick={handleClickButton}>
            {t(
              'fm-triggered-payments.dashboard-cards.low-balance.proceed-with-payment'
            )}
          </Button>
        </Stack>
      }
    />
  );
};
